import { createIcon } from '@chakra-ui/icons';

export const Eye = createIcon({
  displayName: 'Eye',
  viewBox: '0 0 14 12',
  path: [
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 1.34961C8.83151 1.34961 10.3197 2.37298 11.3525 3.39746C12.3871 4.42364 12.9845 5.4701 13.0352 5.56055L13.085 5.66602C13.1858 5.91729 13.1686 6.20323 13.0342 6.44238V6.44336C12.9829 6.53372 12.3818 7.57942 11.3457 8.60449C10.3111 9.6281 8.82262 10.6504 7 10.6504C5.1685 10.6504 3.68029 9.62692 2.64746 8.60254C1.61394 7.57744 1.01732 6.53195 0.96582 6.44043H0.964844C0.811942 6.1679 0.811611 5.83548 0.963867 5.5625L1.10156 5.33105C1.33784 4.95027 1.86488 4.16858 2.63965 3.39844C3.67091 2.37335 5.1596 1.34964 7 1.34961ZM7 3.15039C5.9802 3.15042 5.06832 3.65688 4.33105 4.28613C3.64121 4.87491 3.11904 5.56087 2.81934 5.99902C3.12059 6.43703 3.64517 7.12355 4.33594 7.71289C5.07423 8.34275 5.98528 8.84958 7 8.84961C8.01333 8.84961 8.92385 8.34335 9.66211 7.71387C10.353 7.12475 10.8775 6.43791 11.1797 5.99902C10.878 5.56043 10.3533 4.87473 9.66309 4.28613C8.92487 3.65663 8.01402 3.15039 7 3.15039Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M7 7.5C7.82843 7.5 8.5 6.82843 8.5 6C8.5 5.17157 7.82843 4.5 7 4.5C6.17157 4.5 5.5 5.17157 5.5 6C5.5 6.82843 6.17157 7.5 7 7.5Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
